import $ from 'jquery';
import Form from 'root/module/form';
import View from 'view/base';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Svg_Icon from 'root/module/svg_icon';
import Modals from 'root/modals';
import Tooltip from 'root/module/tooltip';
import Dnd_File_Uploader from 'root/module/dnd_file_uploader';
import Sortable from 'sortablejs';

export default View.extend({
    drag_counter: 0,

    events: {
        'click .logo-upload'                                   : 'onUploadLogo',
        'click .logo-delete'                                   : 'onDeleteLogo',
        'change input[name="icon-toggle"]'                     : 'onToggleIcon',
        'click .radio-box-outro-icon'                          : 'onSelectIcon',
        'click .header-toggle'                                 : 'onToggleHeader',
        'input .update-settings-input'                         : 'updateSettings',
        'change .question-settings-checkbox'                   : 'onToggleCheckbox',
        'change input[name="is-hint-text"]'                    : 'onToggleHintText',
        'change input[name="has-other-answer"]'                : 'onToggleOtherAnswer',
        'click .dropdown-other-answer-type li'                 : 'onSelectOtherAnswerType',
        'input input[name="hint_text"]'                        : 'onInputHintText',
        'change input[name="is-character-limit"]'              : 'onToggleCharacterLimit',
        'click .dropdown-answer-order li'                      : 'onSelectAnswerOrder',
        'click .dropdown-rating-scale li'                      : 'onSelectRatingScale',
        'change input[name="is-scale-label"]'                  : 'onToggleScaleLabel',
        'change input[name="is-answer-order"]'                 : 'onToggleAnswerOrder',
        'click .account-upgrade'                               : 'onAccountUpgrade',
        'input .text-update'                                   : 'onTextUpdate',
        'change textarea[name="dropdown_option"]'              : 'onDropdownOptionChange',
        'click .add-more-multiple-option'                      : 'onAddMoreMultipleOption',
        'click .remove-multiple-option'                        : 'onRemoveMultipleOption'
    },

    dom_handlers: {
        updateSettings: function() {
            this.updateQuestionSettings();
        },
        onToggleCheckbox: function(e) {
            this.updateQuestionSettings();
        },
        onUploadLogo: function(e) {
            Util.uploadImages(1, 10, (result) => {
                if (result[0].error) {
                    UI.error(result[0].error);
                    return;
                }

                this.model.set({
                    'logo_url' : result[0].content,
                    'logo_name': result[0].name,
                    'logo_type': result[0].type
                });
            });
        },

        onDeleteLogo: function(e) {
            e.preventDefault();

            this.model.set('logo_url', '');
            this.updateQuestionSettings();

            // remove tooltips
            Tooltip.removeAll();
        },

        onToggleIcon: function(e) {
            // check if logo is turned on
            var is_toggle_checked = this.$el.find('input[name="icon-toggle"]').prop('checked');
            var is_toggle_on = !is_toggle_checked;

            this.model.set('logo_url', '');
            this.toggleUpdateIcon();
            this.updateQuestionSettings();

            if (is_toggle_on) {
                this.$el.find('.radio-box-outro-icon[data-val="tick"]').click();
            }
        },

        onSelectIcon: function(e) {
            var icon = $(e.currentTarget).data('val');

            this.model.set('logo_url', icon);
            this.updateQuestionSettings();
        },

        onToggleHintText: function(e) {
            this.toggleHintText();
            this.updateQuestionSettings();
        },

        onInputHintText: function(e) {
            this.updateQuestionSettings();
        },

        onToggleCharacterLimit: function(e) {
            this.toggleCharacterLimit();
            this.updateQuestionSettings();
        },

        onSelectAnswerOrder: function(e) {
            $(e.currentTarget).siblings().removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.$el.find('.dropdown-answer-order > button').text($(e.currentTarget).text());

            this.updateQuestionSettings();
        },

        onSelectRatingScale: function(e) {
            $(e.currentTarget).siblings().removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.$el.find('.dropdown-rating-scale > button').text($(e.currentTarget).text());
            this.$el.find('.scale-labels .last-label-number').text(`${$(e.currentTarget).data('val')}:`);

            this.updateQuestionSettings();
        },

        onToggleScaleLabel: function(e) {
            this.toggleScaleLabel();
            this.updateQuestionSettings();
        },

        onToggleAnswerOrder: function(e) {
            this.toggleAnswerOrder();
            this.updateQuestionSettings();
        },

        onToggleOtherAnswer: function(e) {
            this.toggleOtherAnswerSetting();
            this.updateQuestionSettings();

            var has_other_answer = this.$el.find('.has-other-answer').hasClass('switch-on');
            var question_options = [];

            if (this.model.get('question_options')) {
                question_options = JSON.parse(this.model.get('question_options'))
            }

            this.model.set({
                question_options: JSON.stringify(question_options),
            });
        },

        onSelectOtherAnswerType: function(e) {
            $(e.currentTarget).siblings().removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.$el.find('.dropdown-other-answer-type > button').text($(e.currentTarget).text());

            this.updateQuestionSettings();
        },

        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        },
        onTextUpdate: function(e) {
            var name = $(e.currentTarget).attr('name');

            clearTimeout(this.text_update_timeout);
            this.text_update_timeout = setTimeout(() => {
                this.model.set(name, Form.getData(this.$el, name));
            });
        },
        onDropdownOptionChange: function(e) {
            this.updateQuestionSettings();
        },
        onAddMoreMultipleOption: function(e) {
            e.preventDefault();

            // enable the .remove-multiple-option
            this.$el.find('.remove-multiple-option').prop('disabled', false);

            var content = this.getMultipleOptionContent();

            this.$el.find('.multiple-options').append(content);
            // focus on the last input
            this.$el.find('.multiple-input:last input').focus();

            this.updateQuestionSettings();
        },
        onRemoveMultipleOption: function(e) {
            e.preventDefault();

            $(e.currentTarget).closest('.multiple-input').remove();

            this.updateQuestionSettings();

            // return if there is only one option, disable the .remove-multiple-option
            if (this.$el.find('.multiple-input').length === 1) {
                this.$el.find('.remove-multiple-option').prop('disabled', true);
                return;
            }
        }
    },

    event_handlers: {
        handleFiles: function(files) {
            this.drag_counter = 0;
            if (files.length === 0) {
                return;
            }

            if (this.model.get('logo_url')) {
                return;
            }

            var result = Util.readFile(files[0], 10, (file_name, file_type, file_content) => {
                this.model.set({
                    'logo_url' : file_content,
                    'logo_name': file_name,
                    'logo_type': file_type
                });
            });

            if (result !== true) {
                UI.error(result);
            }
        },

        handleDragEnter: function(event) {
            this.drag_counter++;

            if (this.model.get('logo_url')) {
                return;
            }
            this.$el.find('.image-upload').addClass('drop-active');
        },

        handleDragLeave: function(event) {
            this.drag_counter--;
            if (this.drag_counter === 0) {
                this.$el.find('.image-upload').removeClass('drop-active');
            }
        },

        onMultipleOptionSortChange: function(e) {
            this.updateQuestionSettings();
        }
    },

    initialize: function(options) {
        this.survey = options.survey;

        this.listenTo(this.model,  'change:logo_url', this.render);
        this.listenTo(this.survey, 'change:format',   this.render);

        if (this.model.get('question_type') === 'welcome') {
            this.uploader = new Dnd_File_Uploader(
                this.event_handlers.handleFiles.bind(this),
                this.event_handlers.handleDragEnter.bind(this),
                undefined,
                this.event_handlers.handleDragLeave.bind(this),
                false
            );
        }
    },

    toggleUpdateIcon: function() {
        var checked = this.$el.find('input[name="icon-toggle"]').prop('checked');
        var visible = !checked;

        this.$el.find('.icon-menu').toggle(visible);
    },

    toggleHintText: function() {
        var visible = this.$el.find('input[name="is-hint-text"]').prop('checked');

        this.$el.find('.hint-text').toggle(visible);
    },

    toggleCharacterLimit: function() {
        var visible = this.$el.find('input[name="is-character-limit"]').prop('checked');

        this.$el.find('.character-limit').toggle(visible);
    },

    toggleScaleLabel: function() {
        var visible = this.$el.find('input[name="is-scale-label"]').prop('checked');

        this.$el.find('.scale-labels').toggle(visible);
    },

    toggleAnswerOrder: function() {
        var visible = this.$el.find('input[name="is-answer-order"]').prop('checked');

        this.$el.find('.answer-order-setting').toggle(visible);

        var answer_order_type = this.getSelected('answer_order');

        if (visible && !answer_order_type) {
            this.$el.find('.dropdown-answer-order > button').text('Shuffle');
            this.$el.find('.dropdown-answer-order li[data-val="shuffle"]').addClass('selected')
        }
    },

    toggleOtherAnswerSetting: function() {
        var visible = this.$el.find('input[name="has-other-answer"]').prop('checked');

        this.$el.find('.other-answer-setting').toggle(visible);

        var other_answer_type = this.getSelected('other_answer_type');

        if (visible && !other_answer_type) {
            this.$el.find('.dropdown-other-answer-type > button').text('Long');
            this.$el.find('.dropdown-other-answer-type li[data-val="long"]').addClass('selected')
        }
    },

    getSettings: function() {
        var sub_type = this.getSelected('question_sub_type');
        var form_data = Form.getData(this.$el);

        var is_horizontal_layout = this.$el.find('input[name="is-horizontal-layout"]').prop('checked');

        var is_hint_text = this.$el.find('input[name="is-hint-text"]').prop('checked');
        var hint_text = is_hint_text ? form_data.hint_text : '';

        var is_character_limit = this.$el.find('input[name="is-character-limit"]').prop('checked');
        // add validation for min and max
        var character_limit_min = parseInt(form_data.character_limit_min, 10);
        var character_limit_max = parseInt(form_data.character_limit_max, 10);

        if (!isNaN(character_limit_min) && !isNaN(character_limit_max)) {
            character_limit_min = Math.max(character_limit_min, 1);
            character_limit_max = Math.max(character_limit_max, 1);

            // Swap min and max if necessary
            if (character_limit_min > character_limit_max) {
                character_limit_max = character_limit_min + 1; // Increment max by 1
            }
        } else {
            character_limit_min = 0;
            character_limit_max = 100;
        }

        var character_limit = is_character_limit ? `${character_limit_min},${character_limit_max}` : '';

        var is_number = this.$el.find('input[name="is-number"]').prop('checked');

        var is_multiple_select = this.$el.find('input[name="is-multiple-select"]').prop('checked');

        var rating_scale = undefined;

        if (sub_type === 'thumb') {
            rating_scale = 2;
        } else if (sub_type === 'face') {
            rating_scale = 5;
        } else {
            rating_scale = this.$el.find('.dropdown-rating-scale li.selected').data('val');
        }

        var is_scale_label = this.$el.find('input[name="is-scale-label"]').prop('checked');
        var scale_label = is_scale_label ? [form_data.first_label,form_data.last_label] : [];

        var is_answer_order = this.$el.find('input[name="is-answer-order"]').prop('checked');
        var answer_order = '';
        if (is_answer_order) {
            // get the selected value
            answer_order = this.$el.find('.dropdown-answer-order li.selected').data('val');
        }

        var answer_layout = '';
        if (is_horizontal_layout) {
            answer_layout = 'horizontal';
        } else {
            // only set answer_layout to vertical if previous value is horizontal
            // otherwise, keep it empty
            answer_layout = !this.model.get('answer_layout') ? '' : 'vertical';
        }

        var question_options = '';
        var has_other_answer = this.$el.find('input[name="has-other-answer"]').prop('checked');
        var other_answer_type = '';
        var other_answer_hint_text = '';
        var other_answer_character_limit = '';

        if (this.model.get('question_type') === 'dropdown') {
            question_options = JSON.stringify(form_data.dropdown_option.split('\n').filter((item) => item.trim().length > 0));
        } else if (this.model.get('question_type') === 'multiple') {
            var data = this.$el.find('input[name="multiple_option_input"]')
                .map((index, item) => {
                    var value = $(item).val().trim();
                    return value.length > 0 ? value : undefined;
                }).get().filter(value => value !== undefined);

            question_options = JSON.stringify(data);

            if (has_other_answer) {
                other_answer_type = this.$el.find('.dropdown-other-answer-type li.selected').data('val');
                other_answer_hint_text = form_data.other_answer_hint_text;

                var character_limit_min = parseInt(form_data.other_answer_character_limit_min, 10);
                var character_limit_max = parseInt(form_data.other_answer_character_limit_max, 10);
                if (!isNaN(character_limit_min) && !isNaN(character_limit_max)) {
                    character_limit_min = Math.max(character_limit_min, 1);
                    character_limit_max = Math.max(character_limit_max, 1);

                    if (character_limit_min > character_limit_max) {
                        character_limit_max = character_limit_min + 1; // Increment max by 1
                    }
                } else {
                    character_limit_min = 0;
                    character_limit_max = 100;
                }

                other_answer_character_limit = `${character_limit_min},${character_limit_max}`;

                question_options = JSON.parse(question_options);
                // Add other option to the end of the array
                var other_option = this.$el.find('input[name="other_option"]').val().trim() || 'Other';
                question_options.push(other_option);
                question_options = JSON.stringify(question_options);
            }
        }

        var data = {
            button_text       : form_data.button_text,
            is_required       : form_data.is_required && form_data.is_required.length ? true : false,
            answer_layout     : answer_layout,
            hint_text         : hint_text,
            character_limit   : character_limit,
            is_number         : is_number,
            is_multiple_select: is_multiple_select,
            scale             : rating_scale || 0,
            scale_label       : scale_label.length > 0 ? JSON.stringify(scale_label) : '',
            answer_order      : answer_order,
            other_answer_type : other_answer_type,
            other_answer_hint_text: other_answer_hint_text,
            other_answer_character_limit: other_answer_character_limit,
            question_options  : question_options,
        };

        return data;
    },

    getSelected: function(key) {
        return this.model?.get(key);
    },

    updateQuestionSettings: function() {
        var settings = this.getSettings();
        this.model.set(settings);
    },

    renderRatingScale: function(scale) {
        var question_type = this.getSelected('question_type');
        var question_sub_type = this.getSelected('question_sub_type');
        var options = [];

        if (question_type === 'rating') {
            if (question_sub_type === 'number' || question_sub_type === 'star' || question_sub_type === 'heart') {
                options = [5, 10];
            }
        }

        var selected_sacle = scale ? scale : options[0];

        var content = '';

        options.forEach((item) => {
            content += `<li data-val="${item}" class="${selected_sacle === item ? 'selected' : ''}">${item} scale</li>`;
        });

        this.$el.find('.dropdown-rating-scale ul').html(content);
        this.$el
            .find('.dropdown-rating-scale button')
            .text(`${selected_sacle} scale`)
            .prop('disabled', options.length <= 1);

        this.renderLastLabelNumber();
    },

    renderLastLabelNumber: function() {
        var question_type = this.getSelected('question_type');

        var value = undefined;

        if (question_type === 'nps') {
            value = 10;
        } else {
            value = this.$el.find('.dropdown-rating-scale li.selected').data('val');
        }

        if (value) {
            this.$el.find('.scale-labels .last-label-number').text(`${value}:`);
        }
    },

    showHideButtonText: function() {
        var question_type = this.getSelected('question_type');

        if (question_type === 'welcome') {
            if (this.survey.get('format') === 'pageless') {
                this.$el.find('.button-text-section').hide();
            } else {
                this.$el.find('.button-text-section').show();
            }
        }
    },

    getMultipleOptionContent: function(item) {
        return '' +
        '<div class="multiple-input">' +
            '<div>' +
                '<button type="button" class="text-icon remove-multiple-option"><i class="fa-solid fa-circle-minus"></i></button>' +
            '</div>' +
            '<div class="mulitple-option">' +
                '<input type="text" class="solid compact multiple-option-input update-settings-input" name="multiple_option_input" value="' + Util.htmlEntities(item || '') + '">' +
                '<span class="option-drag-handle"></span>' +
            '</div>' +
        '</div>';
    },

    sortable: function() {
        const el = this.$el.find('.dragable-container').get(0);

        if (!el) {
            return;
        }

        new Sortable(el, {
            ghostClass: 'drag-placeholder',
            handle: '.option-drag-handle',
            animation: 200,
            onStart: () => {
                this.$el.find('.multiple-input').addClass('drag-start');
            },
            onEnd: () => {
                this.$el.find('.multiple-input').removeClass('drag-start');
            },
            onSort: this.event_handlers.onMultipleOptionSortChange.bind(this),
        });
    },

    render: function() {
        var question_type = this.getSelected('question_type');
        var question_sub_type = this.getSelected('question_sub_type');
        var logo_url = this.getSelected('logo_url');
        var logo_turned_on = !!logo_url;
        var scale = this.getSelected('scale');
        var scale_label = this.getSelected('scale_label') ? JSON.parse(this.getSelected('scale_label')) : [];

        var logo_content = '';
        if (logo_url) {
            if (logo_url.indexOf('data:image/') !== 0) {
                var logo_ext = logo_url.split('.').pop();
                var logo_path = logo_url.substring(0, logo_url.lastIndexOf('.'));
                var logo_file_name = logo_path.substring(logo_path.lastIndexOf('/') + 1);
                logo_content =
                '<span class="logo-url-name">' + logo_file_name + '</span><span class="logo-ext">.' + logo_ext + '</span>' +
                '<a href="#" class="logo-delete margin-left-8 text-info tooltip" data-title="Remove logo"><i class="fa-solid fa-circle-xmark"></i></a>';
            } else {
                var logo_name = this.model.get('logo_name');
                var logo_ext = logo_name ? logo_name.split('.').pop() : '';
                var logo_path = logo_name ? logo_name.substring(0, logo_name.lastIndexOf('.')) : '';
                logo_content =
                '<span class="logo-url-name">' + logo_path + '</span><span class="logo-ext">.' + logo_ext + '</span>' +
                '<a href="#" class="logo-delete margin-left-8 text-info tooltip" data-title="Remove logo"><i class="fa-solid fa-circle-xmark"></i></a>';
            }
        } else {
            logo_content =
            '<i class="fa-solid fa-upload margin-right-4"></i><span class="margin-right-4">Drop an image or</span>' +
            '<button type="button" class="logo-upload">' + 'click to upload' + '</button>';
        }

        var mulitple_option_content = '';
        var other_option = 'Other';
        if (question_type === 'multiple') {
            var question_options = this.getSelected('question_options');
            var has_other_answer = !!this.getSelected('other_answer_type');

            // parse it to array
            if (question_options) {
                question_options = JSON.parse(question_options);

                // if the question has other answer, remove the last option
                if (has_other_answer) {
                    other_option = question_options.pop();
                }

                var content = '';
                question_options.forEach((item) => {
                    content += this.getMultipleOptionContent(item);
                });

                mulitple_option_content = content;
            }
        }

        // load model data
        var content =
        '<div class="flex-between margin-bottom-16">' +
            '<div class="font-weight-semibold">' + this.model.getName() + '</div>' +
            '<div>' +
                (['short', 'long', 'multiple', 'yesno', 'dropdown', 'rating', 'nps'].indexOf(question_type) === -1 ? '' :
                '<input type="checkbox" name="is_required" class="update-settings-input" value="1" id="is_required_' + this.model.id + '">' +
                '<label for="is_required_' + this.model.id + '" class="full">Required</label>') +
            '</div>' +
        '</div>' +
        '<div class="question-settings-section compact" data-type="welcome">' +
            '<div class="flex-c margin-bottom-12 image-upload">' +
                logo_content +
            '</div>' +
        '</div>' +
        // icon
        '<div class="question-settings-section margin-bottom-12" data-type="thankyou">' +
            '<div class="radio-box-select radio-box-select-border radio-box-select-6 icon-menu">' +
                '<div class="radio-box radio-box-outro-icon hide-border ' + (logo_url === 'tick' ? 'selected' : '') + '" data-val="tick">' + Svg_Icon.check_circle + '</div>' +
                '<div class="radio-box radio-box-outro-icon hide-border ' + (logo_url === 'party' ? 'selected' : '') + '" data-val="party"><span class="emoji">🥳</span></div>' +
                '<div class="radio-box radio-box-outro-icon hide-border ' + (logo_url === 'clap' ? 'selected' : '') + '" data-val="clap"><span class="emoji">👏</span></div>' +
                '<div class="radio-box radio-box-outro-icon hide-border ' + (logo_url === 'thumbup' ? 'selected' : '') + '" data-val="thumbup"><span class="emoji">👍</span></div>' +
                '<div class="radio-box radio-box-outro-icon hide-border ' + (logo_url === 'star' ? 'selected' : '') + '" data-val="star"><span class="emoji">✨</span></div>' +
                '<div class="radio-box radio-box-outro-icon hide-border ' + (logo_url === 'tada' ? 'selected' : '') + '" data-val="tada"><span class="emoji">🎉</span></div>' +
            '</div>' +
        '</div>' +
        '<div class="question-settings-section margin-bottom-24" data-type="thankyou">' +
            '<input type="checkbox" id="icon-toggle" name="icon-toggle" ' + (logo_turned_on ? '' : ' checked') + '>' +
            '<label for="icon-toggle">' +
                '<span>Do not use an icon</span>' +
            '</label>' +
        '</div>' +
        '<div class="question-settings-section margin-bottom-12" data-type="welcome,rating,nps,yesno,multiple,dropdown,short,long,thankyou">' +
            (
                this.model.get('question_label').includes('\n') // check whether its multiline
                ? '<textarea name="question_label" class="text-update solid compact" rows="3"></textarea>'
                : (
                    '<input type="text" name="question_label" class="solid compact text-update" placeholder="' +
                        (this.model.get('question_type') === 'welcome' ? 'Type your text here...' : 'Type your question here...') +
                    '">'
                )
            ) +
        '</div>' +
        '<div class="question-settings-section margin-bottom-12" data-type="welcome,rating,nps,yesno,multiple,dropdown,short,long,thankyou">' +
            '<textarea name="question_desc" class="text-update solid compact" placeholder="Description (optional)" rows="3">' + this.model.escape('question_desc') + '</textarea>' +
        '</div>' +
        // Button text
        '<div class="question-settings-section button-text-section margin-bottom-12" data-type="welcome">' +
            '<div class="margin-bottom-12">Button text</div>' +
            '<input type="text" name="button_text" class="solid compact half update-settings-input" placeholder="Start">' +
        '</div>' +
        // scale
        '<div class="question-settings-section margin-bottom-16" data-type="rating" data-sub-type="star,heart,number">' +
            '<div class="margin-bottom-12">Scale</div>' +
            '<div class="button-dropdown button-dropdown-full dropdown-rating-scale">' +
                '<button type="button" class="dropdown-select"></button>' +
                '<div>' +
                    '<ul class="dropdown dropdown-select"></ul>' +
                '</div>' +
            '</div>' +
        '</div>' +
        // Multiple options selection
        '<div class="question-settings-section multiple-options-selector margin-bottom-16" data-type="multiple">' +
            '<div class="flex-between margin-top-16 margin-bottom-12 font-weight-medium">Answers</div>' +
            '<div class="multiple-options dragable-container margin-bottom-12">' +
                mulitple_option_content +
            '</div>' +
            '<button type="button" class="add-more-multiple-option text-primary-small">' +
                '<i class="fa-solid fa-circle-plus"></i>' +
                'Add more' +
            '</button>' +
            '<hr class="small">' +
        '</div>' +
        // Horizontal layout
        '<div class="question-settings-section" data-type="yesno,multiple">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="is-horizontal-layout" class="question-settings-checkbox" name="is-horizontal-layout" value="1"' + (this.getSelected('answer_layout') === 'horizontal' ? ' checked' : '') + '>' +
                '<label for="is-horizontal-layout">' +
                    '<span>Display answers horizontally</span>' +
                '</label>' +
            '</div>' +
        '</div>' +
        // Hint text
        '<div class="question-settings-section" data-type="short,long">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="is-hint-text" name="is-hint-text" ' + (this.getSelected('hint_text') ? ' checked' : '') + '>' +
                '<label for="is-hint-text">' +
                    '<span>Add hint text</span>' +
                '</label>' +
            '</div>' +
            '<div class="hint-text margin-bottom-16 margin-left-24">' +
                '<input name="hint_text" type="text" class="solid compact" maxlength="48" placeholder="Type your hint text...">' +
                '<div class="maxlength-help"></div>' +
            '</div>' +
        '</div>' +
        // Character limit
        '<div class="question-settings-section" data-type="short,long">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="is-character-limit" name="is-character-limit" ' + (this.getSelected('character_limit') ? ' checked' : '') + '>' +
                '<label for="is-character-limit">' +
                    '<span>Set character limit</span>' +
                '</label>' +
            '</div>' +
            '<div class="character-limit margin-bottom-16 margin-left-24">' +
                '<div>' +
                    '<input name="character_limit_min" type="number" min="1" max="' + (question_type === 'short' ? '100' : '5000') + '" class="solid compact update-settings-input character-limit-min">' +
                    '<div class="character-limit-text-min text-info">Min</div>' +
                '</div>' +
                '<div>' +
                    '<input name="character_limit_max" type="number" min="1" max="' + (question_type === 'short' ? '100' : '5000') + '" class="solid compact update-settings-input character-limit-max">' +
                    '<div class="character-limit-text-max text-info">Max</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        // Allow digits only
        '<div class="question-settings-section" data-type="short">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="is-number" class="question-settings-checkbox" name="is-number" value="1"' + (this.getSelected('is_number') ? ' checked' : '') + '>' +
                '<label for="is-number">' +
                    '<span>Allow digits only</span>' +
                '</label>' +
            '</div>' +
        '</div>' +
        // Multiple selection
        '<div class="question-settings-section" data-type="multiple">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="is-multiple-select" class="question-settings-checkbox" name="is-multiple-select" value="1"' + (this.getSelected('is_multiple_select') ? ' checked' : '') + '>' +
                '<label for="is-multiple-select">' +
                    '<span>Allow multiple selection</span>' +
                '</label>' +
            '</div>' +
        '</div>' +
        // Answer order
        '<div class="question-settings-section" data-type="multiple">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="is-answer-order" name="is-answer-order" value="1"' + (this.getSelected('answer_order') ? ' checked' : '') + '>' +
                '<label for="is-answer-order">' +
                    '<div class="flex-start">' +
                        '<span class="margin-right-4 ' + (Cache.account.hasFeature('survey_answer_order') ? '' : 'text-disabled') + '">Set answer order</span>' +
                        (Cache.account.hasFeature('survey_answer_order') ? '' :
                        '<button type="button" class="account-upgrade float-right tiny shiny"><span>UPGRADE</span></button>') +
                    '</div>' +
                '</label>' +
            '</div>' +
            '<div class="answer-order-setting margin-left-24 margin-bottom-16">' +
                '<div class="button-dropdown button-dropdown-full dropdown-answer-order margin-bottom-16">' +
                    '<button type="button" class="dropdown-select">' + (this.getSelected('answer_order')) + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="shuffle" class="' + (this.getSelected('answer_order') === 'shuffle' ? 'selected' : '') + '">shuffle</li>' +
                            '<li data-val="alphabetical" class="' + (this.getSelected('answer_order') === 'alphabetical' ? 'selected' : '') + '">alphabetical</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        // Add Other answer
        '<div class="question-settings-section" data-type="multiple">' +
            '<div class="flex-between margin-bottom-16">' +
                '<input type="checkbox" id="has-other-answer" name="has-other-answer" value="1"' + (this.getSelected('other_answer_type') ? ' checked' : '') + '>' +
                '<label for="has-other-answer">' +
                    '<span>Add Other answer</span>' +
                '</label>' +
            '</div>' +
            '<div class="other-answer-setting margin-left-24">' +
                '<div class="margin-bottom-12">' +
                    '<input name="other_option" type="text" class="solid compact update-settings-input" placeholder="Type an answer...">' +
                '</div>' +
                '<div class="button-dropdown button-dropdown-full dropdown-other-answer-type margin-bottom-16">' +
                    '<button type="button" class="dropdown-select">' + (this.getSelected('other_answer_type')) + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="short" class="' + (this.getSelected('other_answer_type') === 'short' ? 'selected' : '') + '">Short</li>' +
                            '<li data-val="long" class="' + (this.getSelected('other_answer_type') === 'long' ? 'selected' : '') + '">Long</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<div class="other-hint-text">' +
                    '<input name="other_answer_hint_text" type="text" class="solid compact update-settings-input" maxlength="48" placeholder="Type your hint text...">' +
                    '<div class="maxlength-help"></div>' +
                '</div>' +
                '<div class="other-character-limit">' +
                    '<div>' +
                        '<input name="other_answer_character_limit_min" type="number" min="0" class="solid compact update-settings-input character-limit-min">' +
                        '<div class="character-limit-text-min text-info">Min</div>' +
                    '</div>' +
                    '<div>' +
                        '<input name="other_answer_character_limit_max" type="number" min="0" class="solid compact update-settings-input character-limit-max">' +
                        '<div class="character-limit-text-max text-info">Max</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        // Add Dropdown answer
        '<div class="question-settings-section" data-type="dropdown">' +
            '<div class="flex-between margin-bottom-12">' +
                '<span>Answers</span>' +
            '</div>' +
            '<div class="dropdown-answers margin-bottom-12">' +
                '<textarea name="dropdown_option" class="solid compact" rows="5">' +
                '</textarea>' +
            '</div>' +
        '</div>' +
        // Labels
        '<div class="question-settings-section" data-type="rating,nps" data-sub-type="number">' +
            '<div class="flex-between margin-bottom-12">' +
                '<input type="checkbox" id="is-scale-label" name="is-scale-label" value="1"' + (scale_label.length ? ' checked' : '') + '>' +
                '<label for="is-scale-label">' +
                    '<span>Labels</span>' +
                '</label>' +
            '</div>' +
            '<div class="scale-labels padding-left-24">' +
                '<div class="scale-label">' +
                    '<div class="first-label-number text-info">' + (question_type === 'nps' ? '0' : '1') + ':</div>' +
                    '<input name="first_label" type="text" class="solid compact update-settings-input" maxlength="24" placeholder="' + (question_type === 'nps' ? 'Not at all likely' : 'Not at all satisfied') + '">' +
                    '<div class="maxlength-help"></div>' +
                '</div>' +
                '<div class="divider-12"></div>' +
                '<div class="scale-label">' +
                    '<div class="last-label-number text-info">' + scale + ':</div>' +
                    '<input name="last_label" type="text" class="solid compact update-settings-input" maxlength="24" placeholder="' + (question_type === 'nps' ? 'Extremely likely' : 'Extremely satisfied') + '">' +
                    '<div class="maxlength-help"></div>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        var character_limit = this.getSelected('character_limit');
        var character_limit_min = undefined;
        var character_limit_max = undefined;

        if (character_limit) {
            var character_limit_values = character_limit.split(',');

            character_limit_min = character_limit_values[0];
            character_limit_max = character_limit_values[1];
        }

        var scale_labels = this.getSelected('scale_label');

        scale_labels = scale_labels ? JSON.parse(scale_labels) : [];
        var first_label = scale_labels ? scale_labels[0] : '';
        var last_label = scale_labels ? scale_labels[1] : '';

        var other_answer_type = this.getSelected('other_answer_type');
        var other_answer_hint_text = this.getSelected('other_answer_hint_text');
        var other_answer_character_limit = this.getSelected('other_answer_character_limit');
        var other_answer_character_limit_min = '';
        var other_answer_character_limit_max = '';

        if (other_answer_character_limit) {
            var limit = other_answer_character_limit.split(',');

            other_answer_character_limit_min = limit[0].trim();
            other_answer_character_limit_max = limit[1] ? limit[1].trim() : '';
        }

        // set data for dropdown options
        var dropdown_options = '';
        if (question_type === 'dropdown') {
            var question_options = this.getSelected('question_options');

            // parse it to array
            if (question_options) {
                question_options = JSON.parse(question_options);

                dropdown_options = question_options.join('\n');
            }
        }

        Form.setData(this.$el, {
            is_required: this.getSelected('is_required') ? [1] : [],
            button_text: this.getSelected('button_text'),
            hint_text: this.getSelected('hint_text'),
            character_limit_min: character_limit_min,
            character_limit_max: character_limit_max,
            first_label: first_label,
            last_label: last_label,
            other_answer_type: other_answer_type,
            other_answer_hint_text: other_answer_hint_text,
            other_answer_character_limit_min: other_answer_character_limit_min,
            other_answer_character_limit_max: other_answer_character_limit_max,
            question_label: this.getSelected('question_label'),
            question_desc: this.getSelected('question_desc'),
            dropdown_option: dropdown_options,
            other_option: other_option,
        });

        this.$el
            .find('.question-settings-section')
            .filter(function() {
                var type = $(this).data('type');
                var sub_type = $(this).data('sub-type');

                if (!type) {
                    return false;
                }

                var types = type.split(',');

                // check ranking type
                if (question_type === 'rating' && types.indexOf('rating') !== -1 && sub_type) {
                    var sub_types = sub_type.split(',');

                    return types.indexOf(question_type) !== -1 && sub_types.indexOf(question_sub_type) !== -1;
                } else {
                    return types.indexOf(question_type) !== -1;
                }
            })
            .addClass('active');

        this.toggleUpdateIcon();
        this.toggleHintText();
        this.toggleCharacterLimit();
        this.toggleScaleLabel();
        this.toggleAnswerOrder();
        this.toggleOtherAnswerSetting();

        this.renderRatingScale(scale);

        this.showHideButtonText();

        if (question_type === 'welcome') {
            this.uploader.setupDropArea(this.$el.find('.image-upload').get(0));
        }

        // sortable for multiple question
        if (question_type === 'multiple') {
            this.sortable();
        }

        return this;
    }
});
